import { PublicKey } from '@solana/web3.js';

import { getActiveNetwork, resolveMarketsProgramId } from '@/lib/network/active';
import type { Network } from '@/lib/network/types';

/**
 * The Markets program the given (default: active) network trades on.
 *
 * `@morfi/contract-sdk` helpers default their `programId` to the SDK's own
 * constant, which in a browser bundle is always the devnet deployment. Web
 * code passes this value instead so PDAs and account reads follow
 * `NEXT_PUBLIC_MARKETS_PROGRAM_ID_<NETWORK>` (SDK default when unset).
 */
export function networkProgramId(network: Network = getActiveNetwork()): PublicKey {
  return new PublicKey(resolveMarketsProgramId(network));
}
